import { createSelector } from '@reduxjs/toolkit';
import { ProductAggregated } from 'app/containers/OrderDetails/types';
import { selectPartRealOrderProducts } from 'app/containers/SiteWrapper/selectors';
import { selectCurrentPartOrder } from 'store/slices/activeContentSlice';

export const aggregatedOrderProducts = createSelector(
  [selectPartRealOrderProducts],
  productsOrder => {
    if (productsOrder) {
      const productsMap = new Map<string, ProductAggregated>();

      for (const element of productsOrder) {
        if (productsMap.has(element.reference)) {
          // @ts-ignore
          productsMap.get(element.reference).quantity += 1;
        } else {
          productsMap.set(element.reference, {
            product: element,
            quantity: element.quantity,
          });
        }
      }

      return [...productsMap.values()];
    }
  },
);

export const splitOrderMessages = (messages?: string): string[] =>
  messages ? messages.split('///').filter(Boolean) : [];

export const selectOrderMessagesProductionAndExpedition = createSelector(
  [selectCurrentPartOrder()],
  (partOrder): string[] => {
    const commonMessages: string[] = [];
    if (
      partOrder &&
      partOrder?.orderInfo &&
      partOrder.orderInfo.messagesProduction &&
      partOrder.orderInfo.messagesExpedition
    ) {
      const productionMessages = splitOrderMessages(
        partOrder.orderInfo.messagesProduction,
      );
      const expeditionMessages = new Set(
        splitOrderMessages(partOrder.orderInfo.messagesExpedition),
      );

      for (const message of productionMessages) {
        if (expeditionMessages.has(message)) {
          commonMessages.push(message);
        }
      }
    }
    return commonMessages;
  },
);

export const selectOrderMessagesProduction = createSelector(
  [selectCurrentPartOrder(), selectOrderMessagesProductionAndExpedition],
  (partOrder, commonMessages) => {
    if (partOrder?.orderInfo.messagesProduction) {
      const messages = splitOrderMessages(
        partOrder.orderInfo.messagesProduction,
      );
      return messages.filter(
        message => !commonMessages.find(e => e === message),
      );
    }
  },
);

export const selectOrderMessagesExpedition = createSelector(
  [selectCurrentPartOrder(), selectOrderMessagesProductionAndExpedition],
  (partOrder, commonMessages) => {
    if (partOrder?.orderInfo.messagesExpedition) {
      const messages = splitOrderMessages(
        partOrder.orderInfo.messagesExpedition,
      );
      return messages.filter(
        message => !commonMessages.find(e => e === message),
      );
    }
  },
);

export const selectOrderMessagesDelivery = createSelector(
  [selectCurrentPartOrder()],
  partOrder => splitOrderMessages(partOrder?.orderInfo.messagesDelivery),
);

export const selectOrderMessagesStore = createSelector(
  [selectCurrentPartOrder()],
  partOrder => splitOrderMessages(partOrder?.orderInfo.messagesStore),
);
